import ApprovalIcon from '@mui/icons-material/Approval';

const icons = {
    ApprovalIcon
};

const EscalationApproval = {
    id: 'escalation-approval',
    type: 'group',
    children: [
        {
            id: 'escalation-approval',
            title: 'Escalations Approval',
            type: 'item',
            url: '/Escalations_Approval',
            icon: icons.ApprovalIcon,
        }
    ]
};

export default EscalationApproval;
